export const phone = '(min-width: 0px)';
export const phoneMax = '(max-width: 600px)';
export const tablet = '(min-width: 601px)';
export const tabletMax = '(max-width: 980px)';
export const desktop = '(min-width: 981px)';
export const desktopMax = '(max-width: 1280px)';
export const hd = '(min-width: 1281px)';